import { render, staticRenderFns } from "./PageHeaderOptions.vue?vue&type=template&id=71da31d1&scoped=true&"
import script from "./PageHeaderOptions.vue?vue&type=script&lang=js&"
export * from "./PageHeaderOptions.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderOptions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PageHeaderOptions.vue?vue&type=style&index=1&id=71da31d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71da31d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71da31d1')) {
      api.createRecord('71da31d1', component.options)
    } else {
      api.reload('71da31d1', component.options)
    }
    module.hot.accept("./PageHeaderOptions.vue?vue&type=template&id=71da31d1&scoped=true&", function () {
      api.rerender('71da31d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/PageHeaderOptions.vue"
export default component.exports